import { c as _c } from "react/compiler-runtime";
import { getOtagoRouteBadgeRenderSpec, routeBadgeShape } from "@/lib/routeBadgeSvg";
export default function RouteBadge(t0) {
  const $ = _c(25);
  const {
    className,
    route_color,
    route_text_color,
    routeLabel,
    route_short_name,
    service_id,
    style,
    includeDefaultClassName: t1
  } = t0;
  const includeDefaultClassName = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== routeLabel || $[1] !== route_color || $[2] !== route_short_name || $[3] !== route_text_color || $[4] !== service_id) {
    t2 = getOtagoRouteBadgeRenderSpec({
      routeLabel,
      routeColor: route_color,
      routeTextColor: route_text_color,
      route_short_name,
      service_id
    });
    $[0] = routeLabel;
    $[1] = route_color;
    $[2] = route_short_name;
    $[3] = route_text_color;
    $[4] = service_id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    displayLabel,
    fillColor,
    textColor,
    fontSize,
    yPosition,
    fontWeight,
    fontWidth,
    letterSpacing
  } = t2;
  const t3 = includeDefaultClassName ? `max-h-full max-w-full select-none ${className ? className : ""}` : className;
  let t4;
  if ($[6] !== fillColor) {
    t4 = <rect width={routeBadgeShape.width} height={routeBadgeShape.height} x={routeBadgeShape.x} y={routeBadgeShape.y} fill={fillColor} rx={routeBadgeShape.cornerRadius} />;
    $[6] = fillColor;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${fontWidth}%`;
  const t6 = `${fontWidth}%`;
  const t7 = `"wdth" ${fontWidth}, "wght" ${fontWeight}`;
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = {
      fontStretch: t6,
      fontVariationSettings: t7
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== displayLabel || $[12] !== fontSize || $[13] !== fontWeight || $[14] !== letterSpacing || $[15] !== t5 || $[16] !== t8 || $[17] !== textColor || $[18] !== yPosition) {
    t9 = <text fill={textColor} x="50%" y={yPosition} textAnchor="middle" fontSize={fontSize} letterSpacing={letterSpacing} fontWeight={fontWeight} fontFamily="Bus, sans-serif" fontStretch={t5} style={t8}>{displayLabel}</text>;
    $[11] = displayLabel;
    $[12] = fontSize;
    $[13] = fontWeight;
    $[14] = letterSpacing;
    $[15] = t5;
    $[16] = t8;
    $[17] = textColor;
    $[18] = yPosition;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== style || $[21] !== t3 || $[22] !== t4 || $[23] !== t9) {
    t10 = <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={t3} style={style}>{t4}{t9}</svg>;
    $[20] = style;
    $[21] = t3;
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}